import React from 'react';
import {
  FDContentContainer, FDPrimaryActionIconButton, FDSecondaryActionButton,
  FDSelectInput,
  FDStack,
} from '@facet-wealth/design';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import { useScenarioDetailTableContext } from './ScenarioDetailTableContext';
import ScenarioSelectionDetailedSummarySection from './ScenarioSelectionDetailedSummarySections/ScenarioSelectionDetailedSummarySection';

const ScenarioSelectionDetailedSummaryLayout = ({
  showMonthsProp, hasMaxWidth, handleOnChangePeriod, dense,
}) => {
  const {
    loading,
    columnLabels,
    rowSets,
    onTimeFrameChange,
    tableTimeFrame,
    timeFrameOptions,
    onRowFilterChange,
    rowFilter,
    rowFilterOptions,
    forceShowColumns,
    expandAll,
    setExpandAll,
  } = useScenarioDetailTableContext();
  const isMobile = useMobileLayout();

  if (!rowSets || !columnLabels || !timeFrameOptions || !rowFilterOptions) {
    throw new Error('ScenarioSelectionDetailedSummaryLayout is missing required data');
  }

  const _handleOnChangePeriod = value => {
    if (handleOnChangePeriod) {
      handleOnChangePeriod(value);
    }

    onTimeFrameChange(value); // default behavior
  };

  const getHeaderLabel = () => !forceShowColumns && timeFrameOptions && timeFrameOptions.find(option => option.id === tableTimeFrame)?.prompt;

  const toggleExpandAll = () => setExpandAll(!expandAll);
  const toggleExpandAllIcon = expandAll ? 'keyboardArrowUp' : 'keyboardArrowDown';

  return (
    <FDStack
      direction={'column'}
      spacing={3}
    >
      <FDContentContainer maxWidth="md">{/* Not a problem if this is different from what's below, this content is tiny, we're just ensuring it has the right padding on mobile */}
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 4} justifyContent={'center'} alignItems={isMobile ? undefined : 'center'} flex={1}>
          {isMobile ? null : <FDPrimaryActionIconButton icon={toggleExpandAllIcon} onClick={toggleExpandAll} />}
          <FDSelectInput
            label={'Filter'}
            value={rowFilter}
            options={rowFilterOptions}
            onChange={value => onRowFilterChange(value)}
            required
            {...dataAttrs('scenario-selection-detail-summary-filter-input')}
          />
          <FDSelectInput
            label={'Period'}
            value={tableTimeFrame}
            options={timeFrameOptions}
            onChange={_handleOnChangePeriod}
            required
            {...dataAttrs('scenario-selection-detail-summary-period-input')}
          />
          {isMobile ? <FDSecondaryActionButton icon={toggleExpandAllIcon} label={expandAll ? 'Collapse all' : 'Expand all'} onClick={toggleExpandAll} /> : null}
        </FDStack>
      </FDContentContainer>
      <FDStack direction="column" spacing={2}>
        {loading ? <LoadingIndicator /> : (
          <ScenarioSelectionDetailedSummarySection
            headerLabel={getHeaderLabel()}
            columns={columnLabels}
            data={rowSets}
            test={'planner-detailed-scenario-table'}
            showMonthsProp={showMonthsProp || forceShowColumns}
            hasMaxWidth={hasMaxWidth}
            dense={dense}
          />
        )}
      </FDStack>
    </FDStack>
  );
};


ScenarioSelectionDetailedSummaryLayout.defaultProps = {
  showMonthsProp: false,
  hasMaxWidth: true,
  handleOnChangePeriod: null,
  dense: false,
};

ScenarioSelectionDetailedSummaryLayout.propTypes = {
  showMonthsProp: PropTypes.bool,
  hasMaxWidth: PropTypes.bool,
  handleOnChangePeriod: PropTypes.func,
  dense: PropTypes.bool,
};

export default ScenarioSelectionDetailedSummaryLayout;
